import { useEffect, useRef } from 'react';
import { supabase } from '../lib/supabase';

// Lançamento de tempo herda "faturável" do projeto (coluna projects.billable).
// Falha na consulta devolve null: o rastreador mantém o valor que já tinha.
export async function getProjectBillable(projectId: string): Promise<boolean | null> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, error } = await (supabase as any)
    .from('projects')
    .select('billable')
    .eq('id', projectId)
    .maybeSingle();
  if (error || !data || typeof data.billable !== 'boolean') return null;
  return data.billable;
}

/**
 * Quando o projeto muda, chama `apply` com o "faturável" dele.
 * `enabled = false` (ex.: cronômetro rodando) não mexe no valor atual.
 */
export function useProjectBillableDefault(
  projectId: string | null | undefined,
  apply: (billable: boolean) => void,
  enabled = true
): void {
  const applyRef = useRef(apply);
  applyRef.current = apply;

  useEffect(() => {
    if (!projectId || !enabled) return;
    let cancelled = false;
    getProjectBillable(projectId).then(billable => {
      if (!cancelled && billable !== null) applyRef.current(billable);
    });
    return () => {
      cancelled = true;
    };
  }, [projectId, enabled]);
}
